
            const data = {"name":"arrow-top","data":{"width":"14","height":"15","viewBox":"0 0 14 15","data":"<path pid=\"0\" d=\"M.163 7.488l1.205 1.234L6.146 3.84v10.65h1.709V3.838l4.778 4.883 1.205-1.234L7 .488z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                